import type { FC } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';

import s from './DeviationFlags.scss';

interface Props {
  deviation: PapiDeviation;
  className?: string;
}

const DeviationFlags: FC<Props> = ({ deviation, className }) => {
  const hasFlags = deviation.isMature || deviation.isAiUseDisallowed || deviation.isAiGenerated;
  const { t } = useTranslation();

  if (!hasFlags) {
    return;
  }

  return (
    <div className={c(s['root'], className)}>
      {deviation.isMature && <div className={s['flag']}>{t('studio.table.flags.isMature')}</div>}
      {deviation.isAiGenerated && (
        <div className={s['flag']}>{t('studio.table.flags.isAiGenerated')}</div>
      )}
      {deviation.isAiUseDisallowed && (
        <div className={s['flag']}>{t('studio.table.flags.noai')}</div>
      )}
    </div>
  );
};
DeviationFlags.displayName = 'DeviationFlags';

export default DeviationFlags;
